/**
 * 超管頁面的前端資料快取 — module-level，SPA 切頁不重抓，瀏覽器 refresh 自然清空。
 * 「重新整理」按鈕 / 月份切換到沒看過的月份才會真的打 API。
 */
const store = new Map();

export function getCached(key) {
    return store.get(key) ?? null;
}

export function setCached(key, data) {
    store.set(key, data);
    return data;
}

export function invalidate(prefix) {
    for (const k of store.keys()) {
        if (k.startsWith(prefix)) store.delete(k);
    }
}
